<template>
    <div class="sidebar" v-if="isDesktop">
        <div class="logo flex-center">
            <div @click="goHome">
                <a href="#" class="sidebar-logo">
                    <img v-show="!isCollapse" class="img1" src="@/assets/image/logo@1x.png" alt="" />
                    <!-- <img v-show="!isCollapse" class="img2" src="@/assets/image/logo@1x.png" alt="" /> -->
                   <!-- <span class="logo-mark">B</span>
                    BunnyProxy -->
                </a>
            </div>
        </div>
        <el-menu active-text-color="#ffff" background-color="#0E0E18" text-color="#8A8AA3" :default-active="currentPath"
            class="sidebar-menu" :collapse="isCollapse" :collapse-transition="false" @select="handleSelect">
            <!-- 遍历菜单 -->
            <template v-for="(item, index) in menuList" :key="index">
                <!-- 含有子菜单 -->
                <template v-if="item.children && item.children.length > 0 && !item.meta?.hide">
                    <!-- 第一层 含有子菜单菜单 -->
                    <el-sub-menu :index="item.path">
                        <template #title>
                            <component v-if="isSvgIcon(item.meta.icon)" :is="createSvgIcon(item.meta.icon)"
                                class="icon svg-icon" />
                            <img v-else class="icon" :src="(item.meta.icon ? item.meta.icon : '')" alt="" />
                            <span>{{ item.meta.title }}</span>
                        </template>
                        <!-- 第二层 子菜单遍历 -->
                        <el-menu-item v-for="(secondItem, idx) in item.children"
                            v-show="!secondItem.meta?.hide && !secondItem.meta?.show" :key="idx"
                            :index="getFullPath(item, secondItem)">
                            <text class="item-title">
                                {{ secondItem.meta.title }}
                            </text>
                        </el-menu-item>
                    </el-sub-menu>
                </template>
                <!-- 不含子菜单 -->
                <!-- -if="!item.meta?.hide" -->
                <template v-else>
                    <el-menu-item :index="item.path">
                        <component v-if="isSvgIcon(item.meta.icon)" :is="createSvgIcon(item.meta.icon)"
                            class="icon svg-icon" />
                        <img v-else class="icon" :src="(item.meta.icon ? item.meta.icon : '')" alt="" />
                        <template #title>
                            {{
                                item.meta.title === rocket ? rocket : item.meta.title === langrage['price'] ? rocket :
                                    item.meta.title
                            }}
                            <img v-if="item.meta.title == langrage['helpCenter']" class="menu_link"
                                src="../../assets/images/center/menu_link.png" alt="" />
                        </template>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>

    <!-- 移动端侧边栏菜单 -->
    <div class="mobile-sidebar" v-if="!isDesktop" :class="{ 'mobile-sidebar-open': mobileMenuVisible }"
    :style="{ paddingTop: isActivity ? '4.4rem' : '0' }">
        <div class="mobile-sidebar-header">
            <div class="mobile-user-profile">
                <span class="username">{{ userInfo.user.userName }}</span>
            </div>
            <div class="close-btn" @click="$emit('close')">×</div>
        </div>

        <div class="mobile-menu-tree">
            <div class="menu-item" v-for="item in mobileMenuItems" :key="item.id">
                <div class="menu-item-header"
                    @click="item.children && item.children.length ? toggleMenu(item.id) : handleMobileMenuItemClick(item)"
                    :class="{ 'active': !(item.children && item.children.length) && isMenuItemActive(item.path) }">
                    <span>{{ item.name }}</span>
                    <span v-if="item.children && item.children.length" class="arrow">
                        {{ expandedMenus[item.id] ? '▲' : '▼' }}
                    </span>
                </div>
                <div class="submenu" v-if="item.children && item.children.length && expandedMenus[item.id]">
                    <div class="submenu-item" v-for="child in item.children" :key="child.id"
                        @click="handleMobileMenuItemClick(child)" :class="{ 'active': isMenuItemActive(child.path) }">
                        {{ child.name }}
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-sidebar-footer">
            <div class="wallet-info">
                <img :src="require('@/assets/images/center/Wallet_balance.png')" alt="" />
                <span>{{ langrage['balance'] }}：${{ userInfo.user.walletBalance }}</span>
            </div>
            <div class="mobile-actions">
                <div class="action-item" @click="goMessage">
                    <svg data-v-3f2a3627="" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <circle data-v-3f2a3627="" cx="12" cy="8" r="4"></circle>
                        <path data-v-3f2a3627="" d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2"></path>
                    </svg>
                    <span>{{ langrage['profile1'] }}</span>
                </div>
            </div>
            <div class="mobile-actions">
                <div class="action-item" @click="checkIn">
                    <img :src="require('@/assets/images/center/exit_login.png')" alt="" />
                    <span>{{ langrage['navbar4'] }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- 移动端遮罩层 -->
    <div class="mobile-overlay" v-if="!isDesktop && mobileMenuVisible" @click="$emit('close')"></div>
</template>

<script setup>
    import {
        Document,
        Menu as IconMenu,
        Location,
        Setting
    } from '@element-plus/icons-vue';
    import {
        ref,
        inject,
        computed,
        onMounted,
        watch,
        onBeforeUnmount
    } from 'vue';
    import {
        useRoute,
        useRouter
    } from 'vue-router';
    import {
        useStore
    } from 'vuex';

    const emit = defineEmits(['close']);

    const langrage = inject('langrage');
    const store = useStore();
    const isCollapse = computed(() => store.state.sidebarOpen);
    const router = useRouter();
    const route = useRoute();
    const currentPath = ref('/');
    const userInfo = computed(() => store.state.user.userInfo);

    // 不需要展示在左侧菜单的路由
    const hideMenu = ['/login', '/register', '/resetPassword', '/confirmPassword', '/chService', '/enService',
        '/chPolicy', '/enPolicy',
    ];
    const menuList = ref([]);

    let lang = localStorage.getItem('langrage');
    // 响应式数据，用于判断是否为移动端
    const isDesktop = ref(true)
    const BREAKPOINT = 768
    // 检查屏幕宽度的函数
    const checkScreenSize = () => {
        isDesktop.value = window.innerWidth > BREAKPOINT
    }

    // 获取完整路径的函数
    const getFullPath = (parentItem, childItem) => {
        // 特殊处理帮助中心的子路由
        if (parentItem.path === '/helpCenter') {
            return `/helpCenter/${childItem.path}`;
        }
        // 其他情况保持原来的逻辑
        return parentItem.path + '/' + childItem.path;
    };

    // 监听窗口大小变化
    const handleResize = () => {
        checkScreenSize()
    }

    const goHome = () => {
        if (lang === 'english') {
            window.location.href = '/';
        }
        if (lang === 'chinese') {
            window.location.href = '/';
        }
    };

    // 处理路由
    const handleRoutes = () => {
        const {
            routes
        } = router.options;
        hideMenu.forEach((it) => {
            routes.forEach((item, index) => {
                if (it === item.path) {
                    routes.splice(index, 1);
                }
            });
        });
        // menuList.value = routes;
        //从数组中筛除"CDKEY"
        menuList.value = routes.map(route => {
            if (route.children) {
                return {
                    ...route,
                    children: route.children.filter(child => child.path !== "CDKEY")
                };
            }
            return route;
        });
    };

    // 处理菜单选择事件
    const handleSelect = (key, keyPath) => {
        console.log('Selected key:', key);
        console.log('Key path:', keyPath);

        // 特殊处理帮助中心链接
        if (key === '/helpCenter') {
            window.open('https://help.bunnyproxy.com/');
            return;
        }

        currentPath.value = key;
        router.push({
            path: key
        });
    };

    const toDashboard = () => {
        router.push('/');
        setTimeout(() => {
            location.reload();
        }, 200);
    };

    const rocket = langrage['rocket'];

    // 判断是否为 SVG 图标（包含 SVG 标签）
    const isSvgIcon = (icon) => {
        return typeof icon === 'string' && icon.includes('<svg');
    };

    // 创建 SVG 组件
    const createSvgIcon = (svgString) => {
        return {
            template: svgString
        };
    };

    onMounted(() => {
        handleRoutes();

        console.log('path' + route.path);
        if (route.path == '/dashboard') {
            currentPath.value = `/${route.path.split('/')[0]}`;
        } else if (route.meta.hide) {
            currentPath.value = `/${route.path.split('/')[1]}`;
        } else {
            currentPath.value = route.path;
        }
        checkScreenSize()
        window.addEventListener('resize', handleResize)
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize)
    })

    const handleRouteChange = (newRoute) => {
        if (route.path == '/dashboard') {
            currentPath.value = `/${route.path.split('/')[0]}`;
        } else if (route.meta.hide) {
            currentPath.value = `/${route.path.split('/')[1]}`;
        } else {
            currentPath.value = route.path;
        }
    };

    // 监听路由变化
    watch(
        () => route,
        (newRoute) => {
            handleRouteChange(newRoute);
        }, {
            immediate: true,
            deep: true
        }
    );

    // ========== 移动端相关逻辑 ==========
    const props = defineProps({
        mobileMenuVisible: {
            type: Boolean,
            default: false
        }
    });

    // 移动端菜单数据
    const mobileMenuItems = computed(() => [{
            id: 1,
            name: langrage.center,
            path: '/dashboard',
            children: []
        },
        {
            id: 2,
            name: langrage.productNewName,
            path: '/product/price',
        },
        {
            id: 8,
            name: langrage.mobileName || (lang === 'chinese' ? '移动产品' : 'Mobility Proxy'),
            path: '/mobility/price',
        },
        {
            id: 7,
            name: langrage.sele11 || (lang === 'chinese' ? '无限产品' : 'Infinite Product'),
            path: '/infinite',
            children: [
                {
                    id: 71,
                    name: langrage.sele11 || (lang === 'chinese' ? '无限代理' : 'Infinite Proxy'),
                    path: '/infinite/infinitePrice'
                },
                {
                    id: 72,
                    name: langrage.panel5text12_4 || (lang === 'chinese' ? '无限详情' : 'Infinite Details'),
                    path: '/infinite/infinitePlans'
                }
            ]
        },
        {
            id: 9,
            name: langrage.staticProduct || (lang === 'chinese' ? '静态产品' : 'Static Product'),
            path: '/staticState/staticPrice',
        },
        {
            id: 4,
            name: langrage.getPrice,
            path: '/senior/price',
        },
        {
            id: 3,
            name: langrage.New54,
            path: '/account',
            children: [{
                    id: 31,
                    name: langrage.profile1,
                    path: '/account/profile'
                },
                {
                    id: 32,
                    name: langrage.billing1,
                    path: '/account/billings'
                },
                {
                    id: 34,
                    name: langrage.New81,
                    path: '/account/Union'
                }
            ]
        },
        {
            id: 6,
            name: langrage.dashboard12,
            path: '/helpCenter',
            children: [{
                    id: 61,
                    name: langrage.New15,
                    path: '/helpCenter/guide',
                },
                {
                    id: 61,
                    name: langrage.New103,
                    path: '/helpCenter/index',
                },
                {
                    id: 62,
                    name: langrage.New104,
                    path: '/helpCenter/faq',
                }
            ]
        },
    ]);

    // 移动端菜单展开状态
    const expandedMenus = ref({});

    // 切换菜单展开状态
    const toggleMenu = (id) => {
        expandedMenus.value[id] = !expandedMenus.value[id]
    };

    // 移动端菜单项点击处理
    const handleMobileMenuItemClick = (item) => {
        if (item.path === '/helpCenter') {
            window.open('https://help.bunnyproxy.com/');
        } else {
            router.push(item.path);
        }
        emit('close');
    };

    // 判断菜单项是否激活
    const isMenuItemActive = (itemPath) => {
        return route.path === itemPath || route.path.startsWith(itemPath + '/');
    };

    // 跳转到消息页面
    const goMessage = () => {
        router.push('/account/profile');
        emit('close');
    };

    // 签到处理
    const checkIn = () => {
        // 退出登录逻辑
        localStorage.removeItem('token');
        router.push('/login');
    };
    
    // 活动相关
    const isActivity = computed(() => store.getters.isActivity);
</script>

<style lang="less" scoped>
    .sidebar {
        width: 25rem;
        height: 100vh;
        background: #0E0E18;
        padding: 24px 18px;
        position: sticky;
        top: 0;
        height: 100vh;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        z-index: 50;
        color: #FFFFFF;
        
        

        .logo {
           margin: 0 auto;
           height: 7rem;
           font-size: 3rem;
           color: #fff;
           transition: 0.5s;

            .img1 {
                cursor: pointer;
                width: 20rem;
            }

            .img2 {
                cursor: pointer;
                // width: 13.2rem;
                height: 3rem;
            }
            
            .sidebar-logo {
                display: flex;
                align-items: center;
                gap: 11px;
                font-weight: 700;
                font-size: 19px;
                letter-spacing: -0.02em;
                color: var(--text-white);
                padding: 4px 10px 24px;
                margin-bottom: 16px;
                border-bottom: 1px solid var(--border-dark);
            }
            
            .logo-mark {
                width: 36px;
                height: 36px;
                border-radius: 11px;
                background: linear-gradient(135deg, var(--primary) 0%, var(--neon-pink) 100%);
                display: grid;
                place-items: center;
                color: var(--text-white);
                font-size: 17px;
                font-weight: 800;
                box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                position: relative;
                flex-shrink: 0;
            }
            
            .logo-mark::after {
                content: '';
                position: absolute;
                bottom: -2px;
                right: -2px;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                background: var(--neon-green);
                border: 2px solid var(--bg-dark-elev);
                box-shadow: 0 0 8px rgba(16, 185, 129, 0.6);
            }
            
        }

        .sidebar-menu {
            box-sizing: border-box;
            height: calc(100vh - 8rem);
            overflow-y: scroll;
            transition: 0.5s;
        }

        .icon {
            width: 2.4rem;
            height: 2.4rem;
            color: #8B5CF6;
            margin-right: 1rem;
        }

        .svg-icon {
            fill: currentColor;
        }

        .menu_link {
            position: absolute;
            right: 2.4rem;
            width: 2.4rem;
        }

        .item-title {
            padding-left: 20px;
        }
    }

    ::v-deep {
        .el-menu {
            border-right: none;
        }

        .el-menu-item {
            display: flex;
            align-items: center;
            color: #8A8AA3;
            font-size: 14px;
            font-weight: 500;
            border-radius: 10px;
            transition: all 0.2s var(--ease);
            cursor: pointer;
            text-align: left;
        }


        .el-menu-item.is-active {
            color: var(--text-white);
            background: rgba(139, 92, 246, 0.15);
            font-weight: 600;
        }

        .el-menu-item .el-menu-tooltip__trigger {
            padding: 2rem;
        }




    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .el-menu-item:hover {
        color: #fff;
    }
    
    // .mobile-sidebar {
    //     display: none ;
    // }

    /* ============== RESPONSIVE - 移动端 (max-width: 768px) ============== */
    @media screen and (max-width: 768px) {
        .sidebar {
            display: none !important;
        }

        .mobile-sidebar {
            position: fixed;
            top: 0;
            left: -260px;
            width: 260px;
            height: 100vh;
            background: #0E0E18;
            box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
            z-index: 999;
            transition: left 0.3s cubic-bezier(0.22, 1, 0.36, 1);
            display: flex;
            flex-direction: column;

            &.mobile-sidebar-open {
                left: 0;
            }

            .mobile-sidebar-header {
                padding: 20px 16px;
                border-bottom: 1px solid rgba(15, 15, 26, 0.2);
                background: linear-gradient(180deg, rgba(139, 92, 246, 0.1) 0%, transparent 100%);
                display: flex;
                align-items: center;
                justify-content: space-between;

                .mobile-user-profile {
                    display: flex;
                    align-items: center;
                    gap: 12px;

                    .avatar {
                        width: 44px;
                        height: 44px;
                        border-radius: 12px;
                        border: 2px solid rgba(139, 92, 246, 0.3);
                    }

                    .username {
                        font-size: 15px;
                        font-weight: 600;
                        color: #FFFFFF;
                    }
                }

                .close-btn {
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.6);
                    cursor: pointer;
                    transition: color 0.2s;

                    &:hover {
                        color: #FFFFFF;
                    }
                }
            }

            .mobile-menu-tree {
                flex: 1;
                overflow-y: auto;

                .menu-item {
                    .menu-item-header {
                        padding: 12px 16px;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        color: rgba(255, 255, 255, 0.7);
                        font-size: 14px;
                        font-weight: 500;
                        transition: all 0.2s;
                        cursor: pointer;

                        &:hover {
                            background: rgba(139, 92, 246, 0.1);
                            color: #FFFFFF;
                        }

                        &.active {
                            background: rgba(139, 92, 246, 0.15);
                            color: #8B5CF6;
                            font-weight: 600;
                            border-right: 3px solid #8B5CF6;
                        }

                        .arrow {
                            margin-left: auto;
                            font-size: 10px;
                            color: rgba(255, 255, 255, 0.4);
                        }
                    }

                    .submenu {
                        background: rgba(139, 92, 246, 0.05);

                        .submenu-item {
                            padding: 10px 16px 10px 40px;
                            color: rgba(255, 255, 255, 0.6);
                            font-size: 13px;
                            cursor: pointer;
                            transition: all 0.2s;

                            &:hover {
                                background: rgba(139, 92, 246, 0.1);
                                color: #FFFFFF;
                            }

                            &.active {
                                color: #8B5CF6;
                                font-weight: 600;
                                background: rgba(139, 92, 246, 0.1);
                            }
                        }
                    }
                }
            }

            .mobile-sidebar-footer {
                border-top: 1px solid rgba(15, 15, 26, 0.2);
                padding: 16px 16px 6rem;
                background: rgba(15, 15, 26, 0.1);

                .wallet-info {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 12px;
                    background: rgba(139, 92, 246, 0.1);
                    border-radius: 10px;
                    margin-bottom: 12px;

                    img {
                        width: 20px;
                        height: 20px;
                        filter: brightness(0) invert(1);
                        opacity: 0.8;
                    }

                    span {
                        font-size: 16px;
                        color: #FFFFFF;
                    }
                }

                .mobile-actions {
                    padding: 8px 0;

                    .action-item {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        padding: 10px 12px;
                        border-radius: 8px;
                        cursor: pointer;
                        transition: background 0.2s;

                        &:hover {
                            background: rgba(139, 92, 246, 0.1);
                        }

                        svg,img {
                            width: 18px;
                            height: 18px;
                            filter: brightness(0) invert(1);
                            opacity: 0.7;
                        }

                        span {
                            font-size: 14px;
                            color: rgba(255, 255, 255, 0.8);
                        }
                    }
                }
            }
        }

        .mobile-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(4px);
            z-index: 998;
            transition: opacity 0.3s;
        }
    }
</style>
